export default __webpack_public_path__ + "static/media/Q5.31215444.png";